<template>
  <layout :title="$t('check.title')">
    <template slot="container">
      {{ browserIsValid }}
      <b-button :to="{ name: 'help' }">
        {{ $t('actions.next_step') }}
      </b-button>
    </template>
  </layout>
</template>

<script>
  import Layout from '@/views/Layout';
  import LoadOnNavigate from '@/mixins/load-on-navigate';

  export default {
    name: 'CheckView',
    components: {
      Layout,
    },
    mixins: [
      LoadOnNavigate,
    ],
    data() {
      return {
        isLoading: true,
        test: null,
        browserIsValid: null,
      };
    },
    methods: {
      async load() {
        this.$router.push({ name: 'help' });
      },
    },
  };
</script>
